import React from 'react';
import CHome from './components/home/chome.js';
import NotFound from './components/page404/page404.jsx';
import Main from './main.js';
import { Mainwrap } from './components/main/mainwrap.jsx';
import CIndProduct from './components/indproduct/cindproduct.js';
import CLic  from './components/lic/clic.js';
import CPresentation from './components/presentation/cpresentation.js';
import { CategoryWrap } from './components/categorywrap/categorywrap.jsx';
import CContentView from './components/categorywrap/contentview/ccontentview.js';
import CAdressList from './components/adresslist/cadresslist.js';
import CLending from './components/lending/clending.js';
import DevPages from './components/devpages/devpages.jsx';

const routes = [
  { component: Main,
    routes: [
      { path: '/',
        exact: true,
        component: CLending
      },
      { path: '/home',
        component: CHome,
        routes:[
          { path: '/home/main', component: Mainwrap,
            routes: [
              { path: '/home/main/industry',
                component:  CIndProduct
              },
              { path: '/home/main/lic',
                component:   DevPages
              },
              { path: '/home/main/presentation',
                component:   DevPages
              }
            ]
          },

          { path: '/home/adress', component: CAdressList
          },
          { path: '/home/category', component: CategoryWrap,
            routes:[
              { path: '/home/category/consumer',
                component: CContentView,
                routes: [
                  { path: '/home/category/consumer/rules',
                    component:  CContentView
                  },
                  { path: '/home/category/consumer/prices',
                    component:  CContentView
                  },
                  { path: '/home/category/consumer/rights',
                    component:  CContentView
                  },
                  { path: '/home/category/consumer/nomination',
                    component: CContentView
                  },
                  { path: '/home/category/consumer/operational',
                    component: CContentView
                  },
                  { path: '/home/category/consumer/dispute',
                    component: CContentView
                  },
                  { path: "/home/category/consumer/reporting",
                    component: CContentView
                  },
                  { path: "/home/category/consumer/gastohome",
                    component: CContentView
                  },
                  { path: '/home/category/consumer/gastohome/prices',
                    component:  CContentView
                  },
                  { path: "/home/category/consumer/gastobus",
                    component: CContentView
                  },
                  { path: "/home/category/consumer/infoquestions",
                    component: CContentView
                  }
                ]
              },
              { path: '/home/category/contract',
                component: CContentView,
                routes: [
                  { path: '/home/category/contract/application',
                    component: CContentView
                  },
                  { path: '/home/category/contract/sample',
                    component: CContentView
                  },
                  { path: '/home/category/contract/documents',
                    component:CContentView
                  }

                ]
              },
              { path: '/home/category/other',
                component:CContentView,
                routes: [
                  { path: '/home/category/other/law',
                    component:CContentView
                  },
                  { path: '/home/category/other/links',
                    component:CContentView
                  },
                  { path: '/home/category/other/contact',
                    component:CContentView
                  }
                ]
              },
              { path: '/home/category/company',
                component:CContentView,
                routes: [
                  { path: '/home/category/company',
                    component:CContentView
                  }
                ] }
            ]
          }

        ]

      },

      { path: '*',
        component: NotFound
      }
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/client/routes.js